import { render, staticRenderFns } from "./listimg.vue?vue&type=template&id=64c41210&scoped=true"
import script from "./listimg.vue?vue&type=script&lang=js"
export * from "./listimg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c41210",
  null
  
)

export default component.exports